import { Condition, ConditionData, ConditionHelper, ConditionProviders } from "@app/rule/model/conditions/condition";
import { PropertyChangeCondition } from "@app/rule/model/conditions/property-change-condition";
import { ClassImporterExporter, ImportMap } from "@app/shared/resources/class-importer-exporter.service";
import { PropertyChangeConditionHelper } from "./property-change-condition";

export interface MultiCondition extends Condition {
    conditionType: string;
    conditionId: string;
    name: string;
    [key: number]: PropertyChangeCondition;
}

/* eslint-disable @typescript-eslint/naming-convention */
export interface MultiConditionData extends ConditionData {
    name: string;
    condition_id: string;
    condition_type: string;
    [key: number]: PropertyChangeCondition;
}
/* eslint-enable @typescript-eslint/naming-convention */

export class MultiConditionHelper extends ConditionHelper {
    static isValid(condition: MultiCondition): boolean {
        // TODO - implement
        return true;
    }

    static readonly importMap: ImportMap<MultiCondition, MultiConditionData> = [
        { i: "name", o: "name" },
        { i: "condition_id", o: "conditionId" },
        { i: "condition_type", o: "conditionType" },
    ];

    static fromCHObject(condition): MultiCondition {
        let props = {
            name: condition[this.importMap[0].i],
            conditionId: condition[this.importMap[1].i],
            conditionType: condition[this.importMap[2].i],
        };

        props = Object.assign(props, this.importConditions(condition));

        return props;
    }

    static getDefault(): MultiCondition {
        return {
            name: "Multi Condition",
            conditionId: null,
            conditionType: ConditionProviders.MULTI,
        };
    }

    static importConditions(condition) {
        const conditions = {};

        for (const key in condition) {
            if (!isNaN(+key)) {
                conditions[key] = PropertyChangeConditionHelper.fromCHObject(condition[key]);
            }
        }

        return conditions;
    }

    static clearExistingConditions(condition) {
        for (const key in condition) {
            if (!isNaN(+key)) {
                delete condition[key];
            }
        }

        return condition;
    }

    static getConditions(condition) {
        const conditions = [];

        for (const key in condition) {
            if (!isNaN(+key)) {
                conditions.push(condition[key]);
            }
        }

        return conditions;
    }

    static exportObject(condition, importMap) {
        const newCondition = ClassImporterExporter.exportObject(condition, importMap, false);

        for (const key in condition) {
            if (!isNaN(+key)) {
                newCondition[key] = ClassImporterExporter.exportObject(condition[key], PropertyChangeConditionHelper.importMap);
            }
        }

        return newCondition;
    }
}
